import script from "./WebinarView.vue?vue&type=script&setup=true&lang=js"
export * from "./WebinarView.vue?vue&type=script&setup=true&lang=js"

import "./WebinarView.vue?vue&type=style&index=0&id=2cc3220c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cc3220c"]])

export default __exports__